import { Component, OnInit, Input, AfterViewInit, AfterViewChecked, OnChanges, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { ProblemType, ProblemSource, ProblemStatus, SearchProblem, MenuDictionaries, SetProblemNeighborScope, SearchProblemParsed } from 'src/app/state-management';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { GridComponent } from '@syncfusion/ej2-angular-grids';

@Component({
    selector: 'app-results-view',
    templateUrl: './results-view.component.html',
    styleUrls: ['./results-view.component.scss'],
    standalone: false
})
export class ResultsViewComponent implements OnChanges {

  @Input() searchResults: SearchProblem[];
  @Input() menuDictionaries: MenuDictionaries;
  @Input() noResults: boolean;
  @Input() scrollToResults: boolean;
  @Input() appView: string;
  @Output() SaveFileEmitter = new EventEmitter<string[]>();
  @Output() problemDetailsEmitter = new EventEmitter<string>();
  @Output() openLinkProblemsEmitter = new EventEmitter<SearchProblemParsed[]>();
  @Output() openCaseSummaryEmitter = new EventEmitter<SearchProblemParsed[]>();
  @Output() openCloseProblemsEmitter = new EventEmitter<SearchProblemParsed[]>();

  @ViewChild('grid') grid: GridComponent;

  linkCaseToggleClicked = false;
  closeCaseToggleClicked = false;
  summarizeCasesClicked = false;
  selectedProblemsToLink: SearchProblemParsed[] = [];
  selectedProblemsToClose: SearchProblemParsed[] = [];
  problemsToSummarize: SearchProblemParsed[] = [];
  searchResultsParsed: SearchProblemParsed[];
  testCheck = false;


  constructor(private router: Router, private store: Store<{}>) { }

  // ngOnInit() {

  // }

  ngOnChanges(changes: SimpleChanges) {
    if (this.scrollToResults === true) {
      this.scrollTo('results');
    }
    if (changes.searchResults) {
      this.parseSearchResults(this.searchResults);
      // if (changes.searchResults.previousValue?.length === 0 && this.searchResults.length > 0) {

      // }
      // if (changes.searchResults && changes.searchResults.previousValue && changes.searchResults.currentValue.length === 0) {
      //   // search results cleared
      //   // this.searchResultsParsed = [];
      // }
    }

  }

  goToProblem(problemNo: string) {
    const problemNeighborScope: string[] = [];
    if (!this.noResults) {
      this.searchResults.forEach(result => problemNeighborScope.push(result.caseNumber));
    }

    this.store.dispatch(new SetProblemNeighborScope({ problemNeighborScope: problemNeighborScope }));
    this.router.navigateByUrl('/problemdetails?ProblemNo=' + problemNo);
  }


  getGroupName(id: number): string {
    if (id) {
      return this.menuDictionaries.groupList.get(id)?.name;
    } else {
      return '';
    }
  }

  getProblemType(id: number): ProblemType {
    return this.menuDictionaries.problemTypes.get(id);
  }

  getProblemSource(id: number): ProblemSource {
    return this.menuDictionaries.sourceList.get(id);
  }

  getProblemStatus(id: number): ProblemStatus {
    return this.menuDictionaries.statusList.get(id);
  }

  getAssignee(result: SearchProblem): string {
    let name = 'Unassigned';
    if (result.assigneeId != null) {
      const user = this.menuDictionaries.allUsers.get(result.assigneeId);
      if (user) {
        name = user.firstName + ' ' + user.lastName;
      }
    } else if (result.roleId != null) {
      const role = this.menuDictionaries.roleList.get(result.roleId);
      if (role) {
        name = role.name;
      }
    }
    return name;
  }

  scrollTo(section: string) {
    document.querySelector('#' + section)
      .scrollIntoView(true);
  }

  backToTop() {
    this.scrollTo('top-search');
  }

  toDetails(problemNum: string) {
    this.problemDetailsEmitter.emit(problemNum);
  }

  onClickExport() {
    const strArr = this.processResults(this.searchResults);
    this.SaveFileEmitter.emit(strArr);
  }

  getDate(inputDate: string) {
    const pipe = new DatePipe('en-CA');
    if (inputDate !== null) {
      return pipe.transform(inputDate, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }

  processResults(results: SearchProblem[]) {
    const rowArr: string[] = [];
    const pipe = new DatePipe('en-CA');
    results.forEach(r => {
      const row: string = r.caseNumber + '|' + this.getGroupName(r.groupId) + '|"'
        + this.getProblemType(r.typeId).problemType_Name + '"|"' + r.location.replace(/[\n\r]+/g, '') + '"|'
        + this.getProblemSource(r.sourceId).problemSource_Name + '|'
        + this.getProblemStatus(r.statusId).problemStatus_Name + '|'
        + this.getAssignee(r) + '|"' + r.description.replace(/[\n\r]+/g, '') + '"|'
        + pipe.transform(r.reportedDate, 'yyyy-MM-dd') + '|'
        + this.getDate(r.completedDate) + '|' + r.reporterFirstName + ' ' + r.reporterLastName;
      rowArr.push(row);
    });
    return rowArr;
  }

  onClickSummarizeCases() {
    this.summarizeCasesClicked = !this.summarizeCasesClicked;
    setTimeout(() => {
      this.grid.refreshColumns(); 
    }, 250);
  }

  onClickCancelCaseSummaries() {
    this.summarizeCasesClicked = !this.summarizeCasesClicked;
    this.problemsToSummarize = [];
    setTimeout(() => {
      this.grid.refreshColumns(); 
    }, 250);
  }

  onOpenCaseSummarizePrompt() {
    this.openCaseSummaryEmitter.emit(this.problemsToSummarize);
  }
  
  onClickLinkProblems() {
    this.linkCaseToggleClicked = !this.linkCaseToggleClicked;
    setTimeout(() => {
      this.grid.refreshColumns(); 
    }, 250);
  }

  onClickCancelLinkProblems() {
    this.linkCaseToggleClicked = !this.linkCaseToggleClicked;
    this.selectedProblemsToLink = [];
    setTimeout(() => {
      this.grid.refreshColumns(); 
    }, 250);
  }

  onOpenLinkProblemsPrompt() {
    this.openLinkProblemsEmitter.emit(this.selectedProblemsToLink);
  }

  onClickCloseProblems() {
    this.closeCaseToggleClicked = !this.closeCaseToggleClicked;
    setTimeout(() => {
      this.grid.refreshColumns(); 
    }, 250);
  }

  onClickCancelCloseProblems() {
    this.closeCaseToggleClicked = !this.closeCaseToggleClicked;
    this.selectedProblemsToClose = [];
    setTimeout(() => {
      this.grid.refreshColumns(); 
    }, 250);
    
  }

  onOpenCloseProblemsPrompt() {
    this.openCloseProblemsEmitter.emit(this.selectedProblemsToClose);
  }

  checkAllCheckbox(event: any) {
    const checkBoxElements = document.getElementsByClassName(
      'chkbox'
    );

    for(var i = 0, l = checkBoxElements.length; i < l; ++i) {
      (checkBoxElements[i] as HTMLInputElement).checked = event.target.checked;

      this.handleCheckBoxChange(event, this.searchResultsParsed[i]);
    }
  }

  handleCheckBoxChange(event: any, targetProblem: SearchProblemParsed) {
    let targetArr = this.linkCaseToggleClicked ? this.selectedProblemsToLink : this.closeCaseToggleClicked ? this.selectedProblemsToClose : this.problemsToSummarize;

    if (event.target.checked) {
      targetArr.push(targetProblem);
    } else {
      targetArr = targetArr.filter(problem => problem.problemId !== targetProblem.problemId);
      if (this.linkCaseToggleClicked) this.selectedProblemsToLink = targetArr;
      if (this.summarizeCasesClicked) this.problemsToSummarize = targetArr;
      if (this.closeCaseToggleClicked) this.selectedProblemsToClose = targetArr;
    }
  }

  convertToDateString(reportedDate: string): string {
    const datePart = reportedDate.split('T');
    return datePart[0];
  }

  dataBound(args: any) {
    this.grid.hideScroll();
  }

  stringStripHtmlTags = (htmlString: string) => htmlString.replaceAll("<br>", "\n").replace(/<\/?\w[^>]*>|&\w+/ig, ' ').replaceAll("\n", "<br>").replaceAll("\\n", "<br>");

  parseSearchResults(problems: SearchProblem[]) {
    // if (!this.searchResultsParsed) {
    const parsed: SearchProblemParsed[] = [];
    problems.forEach(p => {
      const parsedObj = {
        problemId: p.problemId,
        caseNumber: p.caseNumber,
        groupName: this.getGroupName(p.groupId),
        typeName: this.getProblemType(p.typeId)?.problemType_Name,
        typeId: p.typeId,
        location: p.location,
        source: this.getProblemSource(p.sourceId)?.problemSource_Name,
        status: this.getProblemStatus(p.statusId)?.problemStatus_Name,
        assignee: this.getAssignee(p),
        description: this.stringStripHtmlTags(p.description),
        reportedDate: this.convertToDateString(p.reportedDate),
        completedDate: p.completedDate ? this.convertToDateString(p.completedDate) : '',
        reporter: p.reporterFirstName + ' ' + p.reporterLastName
      };

      parsed.push(parsedObj);
    });
    this.searchResultsParsed = parsed;

    //}

  }

}
